import ForwardTracker from "../../../../prop-trackers/forward-tracker.js";
import SinglePropTracker from "../../../../prop-trackers/single-prop-tracker.js";
import { Mapper, ValueMapper } from "../../../../prop-tracker-utils/mapper.js";
import Mux from "../../../../prop-tracker-utils/mux.js";

class ObjectGeometryMapper extends ForwardTracker {
    constructor(objDataTracker, geoMuxSource, evtCtx) {
        const mapper = new Mapper(objDataTracker, () => new ObjectMapper(evtCtx, geoMuxSource));
        super(mapper);
    }
}

class ObjectMapper extends ValueMapper {
    constructor(evtCtx, geoMuxSource) {
        super();

        this._evtCtx = evtCtx;
        this._geoMuxSource = geoMuxSource;

        this._geometryKeyTracker = new SinglePropTracker();
        this._geometryTracker = new Mux();

        const needsUpdate = () => this.protected_needsUpdate();
        this._geometryKeyTracker.listenNeedsUpdate(needsUpdate);
        this._geometryTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(data) {
        if (data) {
            this._geometryKeyTracker.track(data, this._evtCtx.getEvents(data), "geometry");
            this._geoMuxSource.addTracker(this._geometryTracker);
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._geometryKeyTracker.track();
        this._geoMuxSource.removeTracker(this._geometryTracker);
    }

    protected_startUpdate() {
        this._geometryKeyTracker.updateIfNeeded(({ prop: { newExists, newValue } }) => {
            this._geometryTracker.setKey(newValue);
        });

        return this._geometryTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._geometryTracker.finishUpdate();
    }
}

export default ObjectGeometryMapper;
